import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { PurchaseMode } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';

const bannerSubTitle = (purchaseMode: PurchaseMode) => {
  switch (purchaseMode) {
    case PurchaseMode.PERSONAL_SALE_AGE_1:
      return 'sale.banner.personal_sale_age_1';
    case PurchaseMode.PERSONAL_SALE_AGE_2:
      return 'sale.banner.personal_sale_age_2';
    case PurchaseMode.PERSONAL_SALE_AGE_3:
      return 'sale.banner.personal_sale_age_3';
    case PurchaseMode.LAST_DAY_SALE:
      return 'sale.banner.last_day';
    case PurchaseMode.SEASONAL_EXTENDED:
      return 'sale.banner.extended';
    default:
      return 'sale.banner.limited_time_only';
  }
};

const SaleBannerSubtitleComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const { purchaseMode } = rootStore.appStore.appContext;
  const { t } = useTranslation();
  return t(bannerSubTitle(purchaseMode));
};

export const SaleBannerSubtitle = withInjectedRootStore(SaleBannerSubtitleComp);
